<template>
    <rkm-overlay>
        <rkm-layout-body title="Fila de atendimento">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/pronto-atendimento/fila-atendimento/List'

export default {
    components: { List },
}
</script>